import React, { Component } from "react";
import Select from "react-select";
import classNames from "classnames";
import { arrayOf, any, bool, func, objectOf, oneOfType, shape, string, number } from "prop-types";

import * as i18n from "util/i18n";

import RadioButtonGroup from "pages/forms/_components/_fields/_commons/RadioButtonGroup";
import FieldLabel from "pages/_components/fields/FieldLabel";
import FieldError from "pages/_components/fields/FieldError";
import withFocus from "pages/_components/withFocus";

import Button from "pages/_components/Button";

class Selector extends Component {
    static propTypes = {
        field: shape({
            name: string,
        }).isRequired,
        form: shape({
            errors: objectOf(oneOfType([string, objectOf(string)])),
            touched: objectOf(oneOfType([arrayOf(bool), bool, objectOf(bool)])),
        }).isRequired,
        idForm: string.isRequired,
        inLineControl: bool,
        isFocused: bool,
        options: arrayOf(objectOf(any)).isRequired,
        renderAs: string,
        toggleIsFocused: func,
        searchable: bool,
        placeholder: string,
        label: string,
        disabled: bool,
        onBlur: func,
        onChange: func,
        hideLabel: bool,
        value: string,
        onInputChange: func,
        isLoading: bool,
        clearable: bool,
        maxLength: number,
        showTooltip: bool,
        onTooltipClick: func,
        labelClassName: string,
        disableUseFieldOnBlur: bool,
    };

    static defaultProps = {
        isFocused: false,
        inLineControl: false,
        renderAs: "combo",
        toggleIsFocused: null,
        searchable: false,
        placeholder: null,
        label: null,
        disabled: false,
        onBlur: () => {},
        onChange: () => {},
        hideLabel: false,
        value: null,
        onInputChange: null,
        isLoading: false,
        clearable: false,
        maxLength: null,
        showTooltip: false,
        onTooltipClick: () => {},
        labelClassName: null,
        disableUseFieldOnBlur: false,
    };

    handleChange = (param) => {
        const { field, form, renderAs, onChange } = this.props;
        let valueParam = param;

        if (renderAs === "combo") {
            if (param !== null) {
                const { value } = param;
                valueParam = value;
            }
        }

        onChange(valueParam);

        form.setFieldValue(field.name, valueParam);
    };

    handleBlur = () => {
        const { field, form, toggleIsFocused, onBlur, disableUseFieldOnBlur } = this.props;
        toggleIsFocused();
        // Se deshabilito opcional porque en algunos casos causa error
        if (!disableUseFieldOnBlur) {
            form.setFieldTouched(field.name);
            onBlur();
        }
    };

    renderAsRadio() {
        const { options, form, field, isFocused, inLineControl, idForm, disabled } = this.props;
        const { touched, errors } = form;
        const hasError = touched[field.name] && errors[field.name];

        return (
            <fieldset
                className={classNames("form-group", {
                    "has-error": touched[field.name] && errors[field.name],
                    "has-focus": isFocused,
                })}>
                <RadioButtonGroup
                    inLineControl={inLineControl}
                    name={field.name}
                    onChange={this.handleChange}
                    optionClassName="needsclick"
                    options={options}
                    value={field.value}
                    selectorId={`${idForm}.${field.name}`}
                    disabled={disabled}
                />
                {hasError && <FieldError error={errors[field.name]} />}
            </fieldset>
        );
    }

    renderAsCombo() {
        const {
            form,
            field,
            isFocused,
            idForm,
            options,
            toggleIsFocused,
            searchable,
            value,
            placeholder,
            label,
            disabled,
            hideLabel,
            onInputChange,
            isLoading,
            clearable,
            maxLength,
            showTooltip,
            onTooltipClick,
            labelClassName,
        } = this.props;
        const { touched, errors } = form;
        const { name } = field;
        const hasError = touched[field.name] && errors[field.name];
        return (
            <div
                className={classNames("form-group", {
                    "has-error": touched[name] && errors[name],
                    "has-focus": isFocused,
                })}>
                <div style={{ display: "flex" }}>
                    {!hideLabel &&
                        (label ? (
                            <FieldLabel idField={field.name} labelText={label} />
                        ) : (
                            <FieldLabel
                                idField={field.name}
                                labelKey={`${idForm}.${field.name}.label`}
                                className={labelClassName}
                            />
                        ))}
                    {showTooltip && (
                        <Button
                            className="icon-button"
                            bsStyle="link"
                            image="images/figma/icon/info.svg"
                            block={false}
                            style={{ padding: "0 0 0 6px" }}
                            onClick={onTooltipClick}
                        />
                    )}
                </div>
                <div className="input-group-standard">
                    <Select
                        className="slideFromBottom flex-container"
                        searchable={searchable}
                        onChange={this.handleChange}
                        clearable={clearable}
                        name={name}
                        value={field.value ? field.value : value}
                        options={options}
                        onBlur={this.handleBlur}
                        onFocus={toggleIsFocused}
                        placeholder={placeholder || i18n.get(`${idForm}.${field.name}.placeholder`)}
                        optionClassName="needsclick"
                        disabled={disabled}
                        onInputChange={onInputChange}
                        isLoading={isLoading}
                        inputProps={{ maxLength: maxLength || null }}
                    />
                </div>
                {hasError && <FieldError error={errors[field.name]} />}
            </div>
        );
    }

    render() {
        const { renderAs } = this.props;

        if (renderAs === "combo") {
            return this.renderAsCombo();
        }
        if (renderAs === "radio") {
            return this.renderAsRadio();
        }

        return null;
    }
}

export default withFocus(Selector);
